import { ALL_BANKS, ALL_CARDS } from '@app/modules/shared/benefits/mappers/partners-collections.mapper';

export function getBanksSubtitle(
  defaultMinPrice: string,
  itemsMinPrice: string,
  subtitle: string,
  bankItems: number[],
  subtitleLastConcat: string
): string {
  const exceptions = {
    bank_items_min_price: itemsMinPrice,
    default_min_price_banks: defaultMinPrice,
    banks: getComponentLabel(ALL_BANKS.map(card => card.name), bankItems, subtitleLastConcat)
  };
  return stringTemplate(subtitle, exceptions);
}

export function getCardsSubtitle(
  defaultMinPrice: string,
  itemsMinPrice: string,
  subtitle: string,
  cardItems: number[],
  subtitleLastConcat: string
): string {
  const exceptions = {
    card_items_min_price: itemsMinPrice,
    default_min_price_cards: defaultMinPrice,
    cards: getComponentLabel(ALL_CARDS.map(card => card.name), cardItems, subtitleLastConcat)
  };
  return stringTemplate(subtitle, exceptions);
}

function getComponentLabel(names: string[], items: number[], concatLast: string): string {
  const limited = names.filter((card, index) => items.includes(index));
  const component = limited.length === 1 ? limited[0] : limited.join(', ');
  return component.replace(/,([^,]*)$/, ` ${concatLast}$1`);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function stringTemplate(str: string, template: { [key: string]: any }): string {
  const regex = new RegExp(Object.keys(template).join('|'), 'g');
  return str.replace(regex, match => template[match]).replace(/\{/g, '').replace(/\}/g, '');
}
